import { queryReminderList, insertReminder, queryOrderList, deleteMaterial, updateMaterial } from "../../api/config/modules/MaintenanceManagement";

const state = {
  queryReminderList: {},
  insertReminder: {},
  queryOrderList: {},
  deleteMaterial: {},
  updateMaterial: {}
};

const mutations = {
  SET_QUERYREMINDERLIST: (state, queryReminderList) => {
    state.queryReminderList = queryReminderList;
  },
  SET_INSERTREMINDER: (state, insertReminder) => {
    state.insertReminder = insertReminder;
  },
  SET_QUERYORDERLIST: (state, queryOrderList) => {
    state.queryOrderList = queryOrderList;
  },
  SET_DELETEMATERIAL: (state, deleteMaterial) => {
    state.deleteMaterial = deleteMaterial;
  },
  SET_UPDATEMATERIAL: (state, updateMaterial) => {
    state.updateMaterial = updateMaterial;
  }
};

const actions = {
  GET_QUERYREMINDERLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryReminderList(data)
        .then((res) => {
          commit("SET_QUERYREMINDERLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTREMINDER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      insertReminder(data)
        .then((res) => {
          commit("SET_INSERTREMINDER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYORDERLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryOrderList(data)
        .then((res) => {
          commit("SET_QUERYORDERLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEMATERIAL: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      deleteMaterial(data)
        .then((res) => {
          commit("SET_DELETEMATERIAL", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEMATERIAL: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      updateMaterial(data)
        .then((res) => {
          commit("SET_UPDATEMATERIAL", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
